import {
  INVOICE_SYMBOL_ACTIVE,
  INVOICE_SYMBOL_ACTIVE_FAIL,
  INVOICE_SYMBOL_ACTIVE_RESET,
  INVOICE_SYMBOL_ACTIVE_SUCCESS,
  INVOICE_SYMBOL_CREATE,
  INVOICE_SYMBOL_CREATE_FAIL,
  INVOICE_SYMBOL_CREATE_RESET,
  INVOICE_SYMBOL_CREATE_SUCCESS,
  INVOICE_SYMBOL_DELETE,
  INVOICE_SYMBOL_DELETE_FAIL,
  INVOICE_SYMBOL_DELETE_RESET,
  INVOICE_SYMBOL_DELETE_SUCCESS,
  INVOICE_SYMBOL_DETAIL,
  INVOICE_SYMBOL_DETAIL_FAIL,
  INVOICE_SYMBOL_DETAIL_RESET,
  INVOICE_SYMBOL_DETAIL_SUCCESS,
  INVOICE_SYMBOL_LIST,
  INVOICE_SYMBOL_LIST_COLUMN,
  INVOICE_SYMBOL_LIST_FAIL,
  INVOICE_SYMBOL_LIST_RESET,
  INVOICE_SYMBOL_LIST_SUCCESS,
  INVOICE_SYMBOL_UPDATE,
  INVOICE_SYMBOL_UPDATE_FAIL,
  INVOICE_SYMBOL_UPDATE_RESET,
  INVOICE_SYMBOL_UPDATE_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List Invoice Symbol
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingList: false,
  errorList: null,

  // Create Invoice Symbol
  create: null,
  loadingCreate: false,
  errorCreate: null,

  // Detail Invoice Symbol
  detail: null,
  loadingDetail: false,
  errorDetail: null,

  // Update Invoice Symbol
  update: null,
  loadingUpdate: false,
  errorUpdate: null,

  // Delete Invoice Symbol
  delete: null,
  loadingDelete: false,
  errorDelete: false,

  // Active Invoice Symbol
  active: null,
  loadingActive: false,
  errorActive: null,
};

const invoiceSymbol = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List Invoice Symbol
    case INVOICE_SYMBOL_LIST:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case INVOICE_SYMBOL_LIST_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case INVOICE_SYMBOL_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case INVOICE_SYMBOL_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-maker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    case INVOICE_SYMBOL_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    // Create Invoice Symbol
    case INVOICE_SYMBOL_CREATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case INVOICE_SYMBOL_CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: { ...action.payload, success: true },
      };
    case INVOICE_SYMBOL_CREATE_FAIL:
      return { ...state, loadingCreate: false, errorCreate: action.payload };
    case INVOICE_SYMBOL_CREATE_RESET:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: null,
      };

    // Detail Invoice Symbol
    case INVOICE_SYMBOL_DETAIL:
      return {
        ...state,
        loadingDetail: true,
        errorDetail: null,
      };
    case INVOICE_SYMBOL_DETAIL_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: { ...action.payload, success: true },
      };
    case INVOICE_SYMBOL_DETAIL_FAIL:
      return { ...state, loadingDetail: false, errorDetail: action.payload };
    case INVOICE_SYMBOL_DETAIL_RESET:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: null,
      };

    // Update Invoice Symbol
    case INVOICE_SYMBOL_UPDATE:
      return {
        ...state,
        loadingUpdate: true,
        errorUpdate: null,
      };
    case INVOICE_SYMBOL_UPDATE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: null,
        update: { ...action.payload, success: true },
      };
    case INVOICE_SYMBOL_UPDATE_FAIL:
      return { ...state, loadingUpdate: false, errorUpdate: action.payload };
    case INVOICE_SYMBOL_UPDATE_RESET:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: null,
        update: null,
      };

    // Delete Invoice Symbol
    case INVOICE_SYMBOL_DELETE:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: null,
      };
    case INVOICE_SYMBOL_DELETE_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: null,
        delete: { success: true },
      };
    case INVOICE_SYMBOL_DELETE_FAIL:
      return { ...state, loadingDelete: false, errorDelete: action.payload };
    case INVOICE_SYMBOL_DELETE_RESET:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: null,
        delete: null,
      };

    // Active Invoice Symbol
    case INVOICE_SYMBOL_ACTIVE:
      return {
        ...state,
        loadingActive: true,
        errorActive: null,
      };
    case INVOICE_SYMBOL_ACTIVE_SUCCESS:
      return {
        ...state,
        loadingActive: false,
        errorActive: null,
        active: { ...action.payload, success: true },
      };
    case INVOICE_SYMBOL_ACTIVE_FAIL:
      return {
        ...state,
        loadingActive: false,
        errorActive: action.payload,
      };
    case INVOICE_SYMBOL_ACTIVE_RESET:
      return {
        ...state,
        loadingActive: false,
        errorActive: null,
        active: null,
      };

    default:
      return state;
  }
};

export default invoiceSymbol;
